/*
 * @Author: louzhedong
 * @Date: 2020-09-10 11:08:08
 * @LastEditors: louzhedong
 * @LastEditTime: 2020-09-28 13:48:34
 * @Description:
 */

import ReactDOM from "react-dom";
import { createHashHistory } from "history";
import { Route, Router, Switch, Redirect } from "react-router-dom";
import BindPage from "./compoment/BindPage";
import Success from "./compoment/Success";
import Expriy from "./compoment/Expriy";
import "./core/index.less";
import Axios from "./core/axios";
import { getParameterByName } from "./core/function";
import User from "./core/user";
import Platform from "./core/platform";
const XMHistory = createHashHistory();
window.XMHistory = XMHistory;

const RootRouter = () => {
  return (
    <Router history={XMHistory}>
      <Switch>
        <Route path="/expriy" render={() => <Expriy />}></Route>
        <Route path="/success" render={() => <Success />}></Route>
        <Route path="/" render={() => <BindPage />} />
      </Switch>
    </Router>
  );
};

const render = () => {
  const MOUNT_NODE = document.getElementById("app");
  const rootInstance = ReactDOM.render(<RootRouter />, MOUNT_NODE);
};

const encryptCode = (len = 32) => {
  const chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
  const maxPos = chars.length;
  let pwd = "";
  for (var i = 0; i < len; i++) {
    pwd += chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return pwd;
};

const code = getParameterByName("code");

if (location.href.indexOf("expriy") > 0) {
  render();
} else {
  if (!code && !User.openId()) {
    User.loginIn();
  } else if (code && !User.openId()) {
    const params = {
      authCode: code,
      appId: window.CONFG.appId,
      userKey: encryptCode(),
    };
    Axios.postJSON("finance/anno/instWallet/getWechatInfoForWallet", params).then(
      (res) => {
        User.setOpenId(res.result.openId);
        User.setAvatar(res.result.headImgUrl);
        User.setNickName(res.result.nickName);
        render();
      }
    );
  } else {
    render();
  }
}

if (module.hot) {
  module.hot.accept();
}
